module.exports = __webpack_public_path__ + "static/media/SOLUS045_GA_PlanView.814c2280.png";